import 'font-awesome/css/font-awesome.min.css'
riot.tag2('star-rating', '  <div class="star fa {size ? sizes[size] : &quot;fa-lg&quot;}{item.selected ? &quot; fa-star&quot; : &quot; fa-star-o&quot;}" each="{item, i in items}" onclick="{select}" no-reorder></div>\n', 'star-rating,[riot-tag="star-rating"],[data-is="star-rating"]{ position: relative; display: block; } star-rating.inline,[riot-tag="star-rating"].inline,[data-is="star-rating"].inline{ display: inline-block; } star-rating .star,[riot-tag="star-rating"] .star,[data-is="star-rating"] .star{ display: inline-block; white-space: nowrap; cursor: pointer; color: #ffaa00; } star-rating .star:hover,[riot-tag="star-rating"] .star:hover,[data-is="star-rating"] .star:hover{ text-shadow: 0 0 3px #885500; }', '', function(opts) {
'use strict';

var self = this;

self.value = 0;

self.sizes = {
    small: '',
    normal: 'fa-lg',
    middle: 'fa-2x',
    large: 'fa-3x',
    big: 'fa-4x'
};

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
        self.update();
    }
});

self.items = [];

self.select = function (e) {
    self.value = e.item.i + 1;

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);

    self.trigger('selected', e.item.i);
};

self.on('update', function () {
    if (opts.value) self.value = parseInt(opts.value);

    if (opts.name) self.root.name = opts.name;

    if (opts.size) self.size = opts.size;

    self.items = [];

    for (var i = 0; i < opts.count; i++) {
        var selected = i < self.value;
        self.items.push({ selected: selected });
    }
});
});


// WEBPACK FOOTER //
// ./components/star-rating.tag